import React, { ReactNode, useState } from 'react';
import { Grid, GridItem, Spacer } from '../../helpers';
import {
  Accordion,
  AccordionItem,
  AccordionItemTrigger,
  AccordionItemContent,
} from '../../components/Accordion';
import { ModuleHeader, SelectCustom } from '../../primitives';
import { LayoutProp } from '~/core/styles/theme/layout';
import styled from '@emotion/styled';

const StyledSelectCustom = styled(SelectCustom)`
  .react-select__control {
    background: white;
  }
`;

const CallToAction = (callToActionProps: CallToActionProps) => {
  const [selectedItem, setSelectedItem] = useState(callToActionProps?.items[0]);

  if (!callToActionProps) return null;
  const {
    title,
    lead,
    items,
    type = 'numbered',
    gridItemSize,
    gridItemPush,
  } = callToActionProps;

  return (
    <>
      <div className="m-calltoaction">
        <Grid columns={{ zero: 12 }}>
          <GridItem
            size={gridItemSize || { zero: 12, ultra: 8 }}
            push={gridItemPush || { zero: 0, ultra: 2 }}
          >
            <ModuleHeader title={title || ''} lead={lead || undefined} />
            {type === 'select' && selectedItem ? (
              <>
                <StyledSelectCustom
                  options={items.map((item) => ({
                    label: item.title,
                    value: item.title,
                  }))}
                  selectedValue={selectedItem.title}
                  selectAllLabel=""
                  onChange={(item: { label: string; value: string }) => {
                    setSelectedItem(items.find((i) => i.title === item.value));
                  }}
                />
                <Spacer space="gamma" />
                <Accordion allowItemCollapse preExpanded={[1]}>
                  <AccordionItem>
                    <AccordionItemTrigger src={selectedItem.iconSrc}>
                      {selectedItem.title}
                    </AccordionItemTrigger>
                    <AccordionItemContent>
                      {selectedItem.richtext}
                    </AccordionItemContent>
                  </AccordionItem>
                </Accordion>
              </>
            ) : (
              <Accordion allowMultipleExpanded allowItemCollapse>
                {items.map((action, rowIndex) => (
                  <AccordionItem key={rowIndex}>
                    <AccordionItemTrigger
                      {...(type === 'numbered'
                        ? { counter: rowIndex + 1 }
                        : { src: action.iconSrc })}
                    >
                      {action.title}
                    </AccordionItemTrigger>
                    <AccordionItemContent>
                      {action.richtext}
                    </AccordionItemContent>
                  </AccordionItem>
                ))}
              </Accordion>
            )}
          </GridItem>
        </Grid>
      </div>
    </>
  );
};

export type CallToActionProps = {
  items: {
    title: string;
    richtext: ReactNode;
    iconSrc?: string;
  }[];
  title?: string;
  lead?: string;
  type?: string;
  gridItemSize?: { [key: LayoutProp['name']]: number };
  gridItemPush?: { [key: LayoutProp['name']]: number };
} | null;

export default CallToAction;
